module.exports = __webpack_public_path__ + "static/img/auto_declare_bg_h5.4d746ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/auto_declare_bg_h5.png
// module id = leUw
// module chunks = 34